export class ProtocolarSeiDTO {
    id?: string;
    conteudo?: string;
}
